<template>
  <pvd-modal
    :id="`${idVal}`"
    :for="`${idVal}-trigger`"
    :class="`${modalClass}`"
    :title="`${modalHeader}`"
  >
    <div slot="modal-body">
      <div
        class="pvd-container"
      >
        <p
          v-if="modalBody1 !== ''"
          :class="`${bodyClass}`"
        >
          {{ modalBody1 }}
        </p>
        <p
          v-if="modalBody2 !== ''"
        >
          {{ modalBody2 }}
        </p>
        <div
          v-if="modalList && modalList.length > 0"
          class="pvd-container"
        >
          <ul class="pvd-list-bullet">
            <li
              v-for="item in modalList"
              :key="item"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <p
          v-if="modalLinkVal !== ''"
          class="xsmall"
        >
          <a
            class="pvd-anchor"
            href="#"
            @click.prevent="exitModal(modalLinkUrl)"
          >
            {{ modalLinkVal }}
          </a>
        </p>
        <p
          v-if="modalListLink && modalListLink.length > 0"
          class="modallinklist"
        >
          <a
            v-for="(modal,index) in modalListLink"
            :key="modal"
            class="pvd-anchor grey-border-bottom"
            href="#"
            @click.prevent="exitModal(index)"
          >
            {{ modal }}
          </a>
        </p>
      </div>
    </div>
    <div
      v-if="modalFooter !== ''"
      slot="modal-footer"
    >
      <div class="pvd-btn-row">
        <div class="button-group">
          <button
            class="pvd-btn btn-action small"
            @click.prevent="closeModal()"
          >
            {{ modalFooter }}
          </button>
          <button
            v-if="modalBtnVal !== ''"
            class="pvd-btn btn-secondary small"
            @click.prevent="exitModal(modalBtnUrl)"
          >
            {{ modalBtnVal }}
          </button>
        </div>
      </div>
    </div>
  </pvd-modal>
</template>

<script>

export default {
  name: 'ModalComponent',
  props: {
    idVal: {
      type: String,
      default: '',
    },
    modalHeader: {
      type: String,
      default: '',
    },
    modalBody1: {
      type: String,
      default: '',
    },
    modalBody2: {
      type: String,
      default: '',
    },
    modalFooter: {
      type: String,
      default: '',
    },
    modalLinkUrl: {
      type: String,
      default: '',
    },
    modalLinkVal: {
      type: String,
      default: '',
    },
    modalBtnUrl: {
      type: [String, Object],
      default: () => {},
    },
    modalBtnVal: {
      type: String,
      default: '',
    },
    modalClass: {
      type: String,
      default: '',
    },
    bodyClass: {
      type: String,
      default: '',
    },
    modalList: {
      type: Array,
      default() {
        return [];
      },
    },
    modalListLink: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    closeModal(event) {
      this.$emit('close-action', event);
    },
    exitModal(url) {
      this.$emit('exitmodal-action', url);
    },
  },
};
</script>

<style scoped>
    .grey-border-bottom {
     border-bottom: 1px solid grey;
    }
    p.modallinklist {
      display:grid
    }
</style>
